import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { VILLES, TERRITOIRES, zoneUrl } from "@/constants/zones";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-anthracite text-ivory mt-24">
      <div className="wrap py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <img src="/brand/logo-full-ivory.png" alt="RAMA DÉCO — Construction & Rénovation" className="brand-logo h-16 md:h-20 mb-6" />
          <p className="text-white/70 max-w-md leading-relaxed">
            Entreprise spécialisée dans les travaux intérieurs, la rénovation et le second œuvre.
            En rénovation d'espaces existants comme en finitions de bâtiments neufs.
          </p>
          <div className="mt-8 space-y-3 text-sm text-white/80">
            <div className="flex items-center gap-3"><MapPin size={16} className="text-bordeaux-500" /> 30 Bis Rue des Mésanges, 93420 Villepinte</div>
            <div className="flex items-center gap-3"><Phone size={16} className="text-bordeaux-500" /> <a href="tel:0627443230" data-testid="footer-phone">06 27 44 32 30</a></div>
            <div className="flex items-center gap-3"><Mail size={16} className="text-bordeaux-500" /> <a href="mailto:sasu.ramadeco@gmail.com">sasu.ramadeco@gmail.com</a></div>
          </div>
        </div>

        <div>
          <div className="font-mono-caption text-white/50 mb-4">Navigation</div>
          <ul className="space-y-2 text-sm text-white/85">
            <li><Link to="/nos-metiers">Nos métiers</Link></li>
            <li><Link to="/comment-ca-marche">Comment ça marche</Link></li>
            <li><Link to="/rama-deco">RAMA DÉCO</Link></li>
            <li><Link to="/blog">Blog — Guides & conseils</Link></li>
            <li><Link to="/blog/zones-intervention">Zones d'intervention</Link></li>
            <li><Link to="/mon-projet">Mon projet</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-mono-caption text-white/50 mb-4">Entreprise</div>
          <ul className="space-y-2 text-sm text-white/80">
            <li>SIREN 824 763 015</li>
            <li>SIRET 824 763 015 000 24</li>
            <li>RCS Bobigny</li>
            <li>Lundi — Samedi, 8h — 19h</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="wrap py-10">
          <div className="font-mono-caption text-white/50 mb-4">Rénovation près de chez vous</div>
          <ul data-testid="footer-zones" className="flex flex-wrap gap-x-4 gap-y-2 text-[0.8rem] text-white/70">
            {[...TERRITOIRES, ...VILLES].map((z) => (
              <li key={z.slug}>
                <Link to={zoneUrl(z.slug)} className="hover:text-ivory underline-offset-4 hover:underline transition-colors">
                  Rénovation {z.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="wrap py-6 flex flex-col md:flex-row items-center justify-between text-xs text-white/50 gap-3">
          <div>© {new Date().getFullYear()} RAMA DÉCO — Tous droits réservés.</div>
          <div>Travaux intérieurs · Rénovation · Second œuvre</div>
        </div>
      </div>
    </footer>
  );
}
